<a [routerLink]="link" class="flex flex-col gap-2 items-center">
    <h3 class="text-xl mobile:text-base" [ngClass]="[isActive ? 'text-primary' : 'text-neutral-500']">{{label}}</h3>
    <div class="h-[2px] w-[35px]" [ngClass]="isActive ? 'bg-primary' : 'bg-neutral-500 invisible'">
    </div>
</a>